import React from 'react';
import Sidebar from './Sidebar';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import ManageDrivers from './ManageDrivers';
import './AdminLayout.css';

const AdminLayout = ({ handleLogout }) => {
  return (
    <div className="admin-layout">
      <Sidebar handleLogout={handleLogout} />
      <div className="admin-content">
        <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/manage-drivers" element={<ManageDrivers />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminLayout; 